import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgbModule, NgbDateNativeAdapter } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgxSpinnerModule } from "ngx-spinner";
import { SetBackgroundImageDirective } from './directive/set-background-image.directive';
import { AlertComponent } from "./components/alert/alert.component";
import { IndianStatesPipe } from "./pipes/utils/indian-states.pipe";
import { DatepickerComponent } from "./components/datepicker/datepicker.component";
import { GoodsServicePipe } from "./pipes/goods-service.pipe";
import { ProductItemPipe } from './pipes/manage/product-item.pipe';
import { DefaultValuePipe } from "./pipes/common/default-value.pipe";
import { IsoWeekPipe } from "./pipes/common/iso-week.pipe";
import { TransactionTypePipe } from './pipes/accounts/transaction-type.pipe';
import { ContactTypePipe } from './pipes/hrm/contact-type.pipe';
import { ImageEditorComponent } from "./components/image-util/image-editor/image-editor.component";
import { WorksheetProductItemPipe } from "./pipes/worksheet/worksheet-product-item.pipe";
import { MonthYearSelectionComponent } from "./components/month-year-selection/month-year-selection.component";
import { PaymentModePipe } from "./pipes/accounts/payment-mode.pipe";
import { SecureResourceUrlPipe } from "./pipes/common/secure-resource-url.pipe";
import { ImageViewerComponent } from "./components/image-util/image-viewer/image-viewer.component";
import { AddressViewComponent } from "./components/contact/address-view/address-view.component";
import { AddressSelectorComponent } from "./components/contact/address-selector/address-selector.component";
import { ContactSelectorComponent } from "@mavles/contacts";
import { DataTableComponent } from "./components/data-table/data-table.component";
import { RenderOrderComponent } from "../order/order-utils/render-order/render-order.component";
import { ContactTagManagerComponent } from "./components/contact-tag-manager/contact-tag-manager.component";
import { ConfirmDialogComponent } from "./components/confirm-dialog/confirm-dialog.component";
import { WeekSelectionComponent } from "./components/week-selection/week-selection.component";
import { AccountsAuditComponent } from "../dashboard/accounts-audit/accounts-audit.component";
import { RemindersHubComponent } from "../hrm/components/reminders/reminders-hub/reminders-hub.component";
import { BaseChartDirective } from "ng2-charts";
import { TamilWordsPipe } from "./pipes/tamil-words.pipe";

@NgModule({
  declarations: [
    SetBackgroundImageDirective,
    AlertComponent,
    IndianStatesPipe,
    GoodsServicePipe,
    DatepickerComponent,
    ProductItemPipe,
    DefaultValuePipe,
    IsoWeekPipe,
    TransactionTypePipe,
    ContactTypePipe,
    ImageEditorComponent,
    WorksheetProductItemPipe,
    MonthYearSelectionComponent,
    PaymentModePipe,
    SecureResourceUrlPipe,
    ImageViewerComponent,
    AddressViewComponent,
    AddressSelectorComponent,
    DataTableComponent,
    RenderOrderComponent,
    ContactTagManagerComponent,
    ConfirmDialogComponent,
    WeekSelectionComponent,
    AccountsAuditComponent,
    RemindersHubComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    NgbModule,
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ContactSelectorComponent,
    BaseChartDirective,
    TamilWordsPipe
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SetBackgroundImageDirective,
    AlertComponent,
    IndianStatesPipe,
    DatepickerComponent,
    GoodsServicePipe,
    ProductItemPipe,
    DefaultValuePipe,
    IsoWeekPipe,
    TransactionTypePipe,
    ContactTypePipe,
    ImageEditorComponent,
    WorksheetProductItemPipe,
    MonthYearSelectionComponent,
    PaymentModePipe,
    SecureResourceUrlPipe,
    ImageViewerComponent,
    AddressViewComponent,
    AddressSelectorComponent,
    DataTableComponent,
    RenderOrderComponent,
    ContactTagManagerComponent,
    ConfirmDialogComponent,
    WeekSelectionComponent,
    ContactSelectorComponent,
    AccountsAuditComponent,
    RemindersHubComponent,
    BaseChartDirective,
    TamilWordsPipe
  ],
  providers: [
    NgbDateNativeAdapter
  ]
})
export class SharedModule { }


